export default __webpack_public_path__ + "static/O0148-bacad961d39fb37283695b098bfcabb2.png";